module.exports = __webpack_public_path__ + "static/media/Crosswinds-West-Condo-Responsibility-Chart.86f6829d.pdf";